import { Component } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router, RouterOutlet } from "@angular/router";
import { SelectionType } from "@swimlane/ngx-datatable";
import { AuthService } from "app/base-module/base-service/auth.service";
import { TipoInvestimento } from "app/constants/tipo-investimento.constants";
import { NgxSortEvent } from "app/shared/types/ngx-datatable-custom";
import { Usuario } from "app/usuarios/models/user.model";
import { ActionDialog, BaseComponent } from "../../base-module/base-component/base.component";
import { AtualizaStatusBoletaComponent } from "../atualiza-status-boleta/atualiza-status-boleta.component";
import { FiltrarBoletaComponent } from "../filtrar-boleta/filtrar-boleta.component";
import { BoletaUnicaService } from "../services/boleta-unica.service";

@Component({
    selector: "app-lista-boleta-unica",
    templateUrl: "./lista-boleta-unica.component.html",
    styleUrls: ["./lista-boleta-unica.component.scss"],
})
export class ListaBoletaUnicaComponent extends BaseComponent {
    user: Usuario;
    public search = new FormControl();
    SelectionType = SelectionType;

    selected: any[] = [];
    data: any = {};

    constructor(
        public service: BoletaUnicaService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private route: Router,
        private _authService: AuthService,
        private outlet: RouterOutlet
    ) {
        super(dialog, snackBar);

        this.data = this.outlet.activatedRouteData["tipo"];

        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser ? strUser : "{}");
        this.search.setValue("");
        this.getAll();
    }
    /**
     * Evento de ordenação da lista de produtos
     * @param event - Evento de ordenação do ngx-datatable
     */
    onSort(event: NgxSortEvent): void {
        this.params.sortColumn = event.column.prop;

        this.params.sortOrder = event.newValue;
        this.getAll();
    }

    /**
     * Evento da paginação
     * @param event - Evento de mudança de página
     */
    pageEvent(event: PageEvent): void {
        this.params.page = event.pageIndex + 1;
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    /**
     * Consulta lista de Boletas
     */
    getAll(): void {
        if (this.search.value) {
            this.params.search = this.search.value;
        }

        this.loadingIndicator = true;
        this.service.getAll(this.params).subscribe({
            next: (data) => {
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];
            },
            error: (error) => {
                if (error.status === 401) {
                    this.showError("Usuário Não Autenticado! Por favor refaça login no sistema");
                    this._authService.logout();
                    this.route.navigate(["/auth/login"]);
                } else {
                    this.showError(`Erro ao buscar boletas: ${error.error?.message || "Erro desconhecido"}`);
                }
            },
            complete: () => {
                this.loadingIndicator = false;
            },
        });
    }

    /**
     * Exclui registro de boleta
     * @param id - ID da boleta a ser excluída
     */
    delete(id: number): void {
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: {
                title: "Excluir boleta",
                text: "Deseja realmente excluir este item?",
                callback: () => {
                    this.dialog.closeAll();

                    this.loadingIndicator = true;
                    this.service.delete(id).subscribe({
                        next: (data) => {
                            this.showSuccess(data.message);
                            this.getAll();
                        },
                        error: (error) => {
                            this.showError(`Erro ao excluir boleta: ${error.error?.message || "Erro desconhecido"}`);
                        },
                        complete: () => {
                            this.loadingIndicator = false;
                        },
                    });
                },
            },
        });
    }
    /**
     * Abre a tela de cadastro de nova boleta única
     */
    openCadastro(): void {
        this.route.navigate(["/movimentacao/boleta-unica/cadastro"]);
    }

    /**
     * Abre a tela de edição de uma boleta existente
     * @param id - ID da boleta a ser editada
     */
    openAlterar(id: number): void {
        this.route.navigate(["/movimentacao/boleta-unica/cadastro/" + id]);
    }

    /**
     * Modal de Filtro
     */
    openFiltro(): void {
        const dialogRef = this.dialog.open(FiltrarBoletaComponent, {
            width: "700px",
            maxHeight: "99vh",
            data: {
                titulo: "Filtro Boleta Unica",
                status_boleta: true,
                status_ordem: false,
                tipo: TipoInvestimento.RENDA_VARIAVEL,
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result !== "cancel" && result !== undefined) {
                this.params.data_operacao_inicio = result.data_operacao_inicio;
                this.params.data_operacao_fim = result.data_operacao_fim;

                if (result.cliente !== undefined && result.cliente !== null) {
                    this.params.cliente_id = result.cliente.id;
                }

                if (result.assessor_id !== undefined && result.assessor_id !== null) {
                    this.params.assessor_id = result.assessor_id;
                }

                if (result.escritorio_id !== undefined && result.escritorio_id !== null) {
                    this.params.escritorio_id = result.escritorio_id;
                }

                if (result.status_id !== undefined && result.status_id !== null) {
                    this.params.status_id = result.status_id;
                }

                if (result.acao_comercial_id !== undefined && result.acao_comercial_id !== null) {
                    this.params.acao_comercial_id = result.acao_comercial_id;
                }

                this.paginator.firstPage();
                this.getAll();
            }
        });
    }

    /**
     * Manipula a seleção de itens na tabela
     * @param selectedEvent - Evento contendo os itens selecionados
     */
    onSelect(selectedEvent: { selected: any[] }): void {
        const selectedItems = Array.isArray(selectedEvent?.selected) ? selectedEvent.selected : [];

        this.selected.splice(0, this.selected.length);
        this.selected.push(...selectedItems);
    }

    /**
     * Abre modal para atualizar status das boletas selecionadas
     */
    openAtualizar(): void {
        if (this.selected.length === 0) {
            this.showError("Selecione pelo menos uma boleta para realizar a atualização do status");
            return;
        }

        const dialogRef = this.dialog.open(AtualizaStatusBoletaComponent, {
            width: "700px",
            data: {
                boletas: this.selected,
                tipo: "Unica",
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result !== "cancel" && result !== undefined) {
                this.getAll();
                this.selected = [];
            }
        });
    }

    /**
     * Visualizar Dados da Boleta Única
     * @param id - ID da boleta a ser visualizada
     */
    openVisualizar(id: any): void {
        this.route.navigate(["/movimentacao/boleta-unica/visualizar/" + id]);
    }

    /**
     * Exporta a lista de boletas para arquivo Excel
     */
    getAllExport(): void {
        this.openLoading();
        this.service.getAllExport(this.params).subscribe({
            next: (data) => {
                const blob = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                window.open(url, "_blank");
            },
            error: (error) => {
                this.closeLoading();
                this.showError(`Erro ao exportar boletas: ${error.error?.message || "Erro desconhecido"}`);
            },
            complete: () => {
                this.closeLoading();
            },
        });
    }
}
